(function(){
  if (window.__kvInit) return; window.__kvInit = true;
  function reveal(){
    var els = document.querySelectorAll('[data-kv-reveal]:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function(e){e.classList.add('is-in')}); return; }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if (en.isIntersecting){ en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function(e){ io.observe(e); });
  }
  function steps(){
    document.querySelectorAll('[data-kv-steps]').forEach(function(box){
      if (box.__kv) return; box.__kv = true;
      var items = box.querySelectorAll('.kv-step');
      var wrap = box.closest('.kv-steps');
      var pics = wrap ? wrap.querySelectorAll('.kv-steps__pic') : [];
      function show(i){
        items.forEach(function(x, n){ x.classList.toggle('is-on', n === i); });
        pics.forEach(function(p, n){ p.classList.toggle('is-on', n === i); });
      }
      items.forEach(function(it, i){ it.addEventListener('click', function(){ show(i); }); });
      var cur = 0, auto = setInterval(function(){ cur = (cur + 1) % items.length; show(cur); }, 4500);
      box.addEventListener('click', function(){ clearInterval(auto); });
    });
  }
  // "Perfect for" band: same pixel speed as the scrolling band above it
  function syncSpeed(){
    var top = document.querySelector('.kv-marq__track');
    if (!top) return;
    var dur = parseFloat(getComputedStyle(top).animationDuration) || 30;
    var pxPerSec = (top.scrollWidth / 2) / dur;
    document.querySelectorAll('.kv-made__track').forEach(function(t){
      if (pxPerSec > 0) t.style.setProperty('--kv-made-speed', ((t.scrollWidth / 2) / pxPerSec).toFixed(2) + 's');
    });
  }
  // Add to cart opens the side cart (like Amverio) instead of going to /cart.
  function ajaxCart(){
    if (window.__kvAtc) return; window.__kvAtc = true;
    document.addEventListener('submit', function(e){
      var form = e.target;
      if (!form.matches || !form.matches('[data-kv-form]')) return;
      if (e.submitter && e.submitter.name !== 'add') return; // e.g. dynamic checkout buttons
      var items = null;
      try { items = form.dataset.kvItems ? JSON.parse(form.dataset.kvItems) : null; } catch (err) { items = null; }
      var drawer = document.querySelector('cart-drawer');
      var hasDrawer = drawer && typeof drawer.renderContents === 'function';
      if (!hasDrawer && !items) return; // no drawer and one colour only: normal submit
      e.preventDefault();
      var btn = form.querySelector('[data-kv-atc]');
      if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
      var fd = new FormData();
      if (items) {
        // several colours in one pack: one cart line per colour
        items.forEach(function(it, i){ fd.append('items[' + i + '][id]', it.id); fd.append('items[' + i + '][quantity]', it.quantity); });
      } else {
        fd = new FormData(form);
      }
      if (!hasDrawer) {
        fetch((window.routes && window.routes.cart_add_url) || '/cart/add', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
          .then(function(){ window.location.href = (window.routes && window.routes.cart_url) || '/cart'; })
          .catch(function(){ form.submit(); });
        return;
      }
      fd.append('sections', drawer.getSectionsToRender().map(function(s){ return s.id; }));
      fd.append('sections_url', window.location.pathname);
      if (drawer.setActiveElement) drawer.setActiveElement(document.activeElement);
      fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
        method: 'POST', body: fd,
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' }
      }).then(function(r){ return r.json(); }).then(function(res){
        if (res.status) { form.submit(); return; } // error (e.g. sold out): fall back to the normal page
        drawer.classList.remove('is-empty');
        drawer.renderContents(res);
      }).catch(function(){ form.submit(); }).finally(function(){
        if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); }
      });
    });
  }
  // Judge.me: show reviews with photos first by default (all reviews stay visible; the shopper can still change the order).
  function reviewsPicturesFirst(){
    var tries = 0;
    var t = setInterval(function(){
      var s = document.querySelector('#judgeme_product_reviews .jdgm-sort-dropdown');
      if (s && !s.dataset.kvSorted) {
        s.dataset.kvSorted = '1';
        clearInterval(t);
        if (s.value !== 'pictures_first') { s.value = 'pictures_first'; s.dispatchEvent(new Event('change', { bubbles: true })); }
      } else if (++tries > 40) clearInterval(t);
    }, 500);
  }
  function init(){ reveal(); steps(); syncSpeed(); ajaxCart(); reviewsPicturesFirst(); }
  window.addEventListener('load', syncSpeed);
  window.addEventListener('resize', syncSpeed);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
